<template>
<!-- 线下考试登分 -->
  <popup ref="popup" :loading="popupLoading" @beforeClose="close">
    <div slot="body" style="padding-top: 20px">
      <div class="operator">
        <el-row>
          <el-col :span="4">
            <span class="text">
              <span> 总分 ：{{ maxScore }}</span>
            </span>
          </el-col>
          <el-col :span="20">
            <span class="text">
              <span v-if="studentNoList"> 未考 ：{{ studentNoList }}</span>
              <span v-else> 应考 ：{{ studentNeedList }}</span>
            </span>
          </el-col>
        </el-row>
      </div>
      <el-form class="dataForm" ref="form" :disabled="disabled" :inline="true">
        <el-row>
          <el-col :span="24">
            <!-- 学生列表 -->
            <el-card v-for="(stu, idx1) in studentList" :key="idx1 + '5'">
              <div v-if="idx1 == 0"><el-divider content-position="left"> <span
                    style="color:#CC0000">考试学生</span></el-divider>
              </div>
              <b>{{ idx1 + 1 }}.</b> <b>{{ stu.name }}</b>
              登记得分：<input :disabled="disabled" placeholder="旷考或白卷请登0分" size="20" type="text" v-model="stu.score" />
            </el-card>
          </el-col>
        </el-row>
      </el-form>

    </div>
    <div slot="footer">
      <el-row>
        <el-col :span="3">
          <el-button type="primary" :loading="confirmLoading" @click="close()">关 闭</el-button>
        </el-col>
        <el-col :span="3">
          <el-button type="danger" v-if="!anwsers" @click="submitPigai()">提 交</el-button>
        </el-col>
        <el-col :span="18">

        </el-col>
      </el-row>
    </div>
  </popup>
</template>
<script>
import popup from "@/components/popup/drawerPopupSta.vue";
import FillInTheBlanks from "@/components/exams/FillInTheBlanks.vue";
import api from "@/api/exams/exams/exams.js";
import ansrApi from "@/api/exams/answers/answers.js";

export default {
  components: {
    popup,
    FillInTheBlanks
  },
  data() {
    return {
      countDown: "",
      popupLoading: false,
      disabled: false,
      confirmLoading: false,

      kid: '',                //考试id
      studentList: [],        //应考学生列表
      studentNeedList: "",    //应考学生列表txt
      studentNoList: false,      //旷考学生列表
      anwsers: false,

      expId: null,            //试卷ID
      needExmCnt: 0,          //该考试的人数
      corectCnt: 0,           //已批改人数

      maxScore: 0,            //试卷总分

    };
  }, methods: {


    submitPigai() {
      //询问是否完成批改？完成批改  ： 暂存成绩
      this.$confirm('是否提交当前成绩？', '试卷批改提示', {
        distinguishCancelAndClose: true, confirmButtonText: '提交', cancelButtonText: '取消'
      }).then(() => {
        //  卷封装答案
        let records = []
        this.studentList.forEach(v => {
          if (v.score && v.score > 0) {
            //哪个学生参加哪个考试的分数
            let stu = { id: v.id, kid: this.kid, score: v.score }
            records.push(stu)
          }
        });

        //提交判卷
        ansrApi.saveAll(records, res => {
          this.$utils.msg.success(res.msg);
          this.close()
        }, err => {
          this.$utils.msg.warning(err.msg);
        })
      })
    },
    //打开弹框
    open(kid, title, disabled) {
      this.kid = kid;
      // 加载试卷+考试
      api.findPaperByKid({ kid: this.kid }, res => {

        //考试
        let exam = res.data.exm

        //试卷ID
        this.expId = exam.expid

        //已批改的人数
        this.corectCnt = res.data.corectCnt * 1


        //参加考试的学生
        this.studentList = res.data.students
        this.studentNeedList = exam.sid

        //初始化第一个学生答案
        //试卷中的试题ID---->试题
        api.getexpContent({ expid: this.expId }, (response) => {
          //试卷
          this.exp = JSON.parse(response.data);
          this.maxScore = this.exp.score;
          this.$refs.popup.open(title, "100%");
          //2. 发起请求 根据  考试ID +学生ID 查回一个试卷+答案

          //取回该考试的答案
          ansrApi.listAnsByKid({ kid: this.kid }, res3 => {
            if (res3.data.length > 0) {
              this.anwsers = res3.data
              this.disabled = true
              //如果是已批改过的
              let stuTmps = []
              for (let i = 0; i < this.anwsers.length; i++) {
                const anw = this.anwsers[i];
                for (let j = 0; j < this.studentList.length; j++) {
                  const stu = this.studentList[j];
                  if (anw.sid == stu.id) {
                    stu.score = anw.score
                    stuTmps.push(stu)
                    break;
                  }
                }
              }
              this.studentList = stuTmps

              //计算未考的人
              if (this.corectCnt > 0) {
                let stuStr = ""
                this.studentList.forEach(v => {
                  stuStr += "_"
                  stuStr += v.name
                })

                let arr = JSON.parse(this.studentNeedList)[0]
                this.studentNoList =[]
                arr.forEach(v => {
               //   console.log(stuStr, v)
                  if (stuStr.indexOf(v) > 0) {
                  } else {
                    this.studentNoList.push(v)
                  }
                })
              }

            } else {
              this.disabled = false
            }
          })

        });

        this.disabled = disabled;
      })

    },
    close() {
      this.disabled = false;
      this.$refs.popup.closeCallback();
      //退出初始化参数
      this.score = 0;
      this.countDown = "";
      this.popupLoading = false;
      this.disabled = false;
      this.confirmLoading = false;
      this.exam = {};
      this.examPapers = {}    //伪数组  :把对象当数组用，实现'键值对'Map
      this.maxScore = 0,    //试卷总分
        this.$parent.list();

    }


  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.text {
  display: inline-block;
  padding: 0 20px;
}

.operator {
  position: absolute;
  top: 50px;
  width: 100%;
  background-color: rgba(255, 255, 255, .8);
  z-index: 999;
}

.title-style-bold {
  color: #000;
  font-weight: bold;
}

.title-color-red {
  color: red;
}

.margin-top-20 {
  margin-top: 20px;
  display: block;
}

.update-note {
  display: block;
  margin-top: 20px;
}
</style>